import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Menu, X } from 'lucide-react';
import { CartContext } from '../App';

export const Navbar = () => {
  const { cartCount } = useContext(CartContext);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass-nav border-b border-black/10" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <span className="font-heading text-2xl font-semibold tracking-tight text-[#C4A882]">in-dekor™</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="font-body text-sm tracking-wide text-[#1A1A1A] hover:text-[#C4A882] transition-colors" data-testid="nav-home">
              Home
            </Link>
            <Link to="/products" className="font-body text-sm tracking-wide text-[#1A1A1A] hover:text-[#C4A882] transition-colors" data-testid="nav-products">
              Products
            </Link>
            <Link to="/about" className="font-body text-sm tracking-wide text-[#1A1A1A] hover:text-[#C4A882] transition-colors" data-testid="nav-about">
              About
            </Link>
            <Link to="/contact" className="font-body text-sm tracking-wide text-[#1A1A1A] hover:text-[#C4A882] transition-colors" data-testid="nav-contact">
              Contact
            </Link>
          </div>

          {/* Cart & Mobile Menu */}
          <div className="flex items-center space-x-4">
            <Link to="/cart" className="relative" data-testid="nav-cart">
              <ShoppingCart className="w-6 h-6 text-[#1A1A1A]" />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#C4A882] text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium" data-testid="cart-count">
                  {cartCount}
                </span>
              )}
            </Link>
            
            <button 
              className="md:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-black/10" data-testid="mobile-menu">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="font-body text-sm text-[#1A1A1A] hover:text-[#C4A882]" onClick={() => setIsMenuOpen(false)}>
                Home
              </Link>
              <Link to="/products" className="font-body text-sm text-[#1A1A1A] hover:text-[#C4A882]" onClick={() => setIsMenuOpen(false)}>
                Products
              </Link>
              <Link to="/about" className="font-body text-sm text-[#1A1A1A] hover:text-[#C4A882]" onClick={() => setIsMenuOpen(false)}>
                About
              </Link>
              <Link to="/contact" className="font-body text-sm text-[#1A1A1A] hover:text-[#C4A882]" onClick={() => setIsMenuOpen(false)}>
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <span className="font-heading text-2xl font-semibold tracking-tight text-[#C4A882]">in-dekor™</span>
            <p className="font-body text-sm text-gray-400 max-w-md leading-relaxed mt-4">
              Premium furniture crafted with passion in Mumbai. Transforming spaces with timeless design and exceptional quality since our inception.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm uppercase tracking-[0.2em] mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/products" className="font-body text-sm text-gray-400 hover:text-[#C4A882] transition-colors">Products</Link></li>
              <li><Link to="/about" className="font-body text-sm text-gray-400 hover:text-[#C4A882] transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="font-body text-sm text-gray-400 hover:text-[#C4A882] transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm uppercase tracking-[0.2em] mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-gray-400 font-body">

              <li>
                <span className="block text-white text-xs uppercase tracking-wider mb-1">Workshop</span>
                95, Nizam Street,<br />
                Mumbai - 400003
              </li>
              <li className="pt-2">
                <a href="mailto:usmanfurniturewala@gmail.com" className="text-[#C4A882] hover:underline">
                  usmanfurniturewala@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="font-body text-xs text-gray-500">
            © {new Date().getFullYear()} in-dekor™. All rights reserved. Owned by Usman Furniturewala.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Navbar;
